<template>
  <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-row class="no-gutters">
      <v-col cols="12" sm="6" md="4">
          <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search Acc No..." single-line solo
              hide-details></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="3">
          <v-select solo :items="managerAllAccounts()" v-model="account" @input="managerAccountFilter"
              append-icon="mdi-chevron-down" label="All Accounts" class="custom-select"></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="2">
          <ul>
              <li>
                  <span class="text--green">Total Commission Earned:</span>
                  <span>${{ totalCommission ?.toFixed(2) }}</span>
              </li>
          </ul>
      </v-col>
    </v-row>
    
    <v-row></v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
          <v-sheet class="transactionTable liveTradeTable walletTable pb-3"
                   :color="$vuetify.theme.dark ? '#1A2A3E' : '#F1F7FB'">
            <v-data-table
              :headers="headers"
              :items="filteredData"
              :search="search"
              :items-per-page="10"
            >
              <template v-slot:item.amount="{ item }">
                ${{ parseFloat(item.amount).toFixed(2) }}
              </template>

              <template v-slot:item.investor_total_profit="{ item }">
                {{ item.investor_total_profit ?? 'N/A' }}
              </template>

              <template v-slot:item.profit_sharing="{ item }">
                {{ item.profit_sharing ? item.profit_sharing + '%' : 'N/A' }}
              </template>

              <template v-slot:item.investor_retained_profit="{ item }">
                {{ item.investor_retained_profit ?? 'N/A' }}
              </template>

              <template v-slot:item.start_date="{ item }">
                {{ formatMySQLDate(item.start_date) }}
              </template>

              <template v-slot:item.end_date="{ item }">
                {{ formatMySQLDate(item.end_date) }}
              </template>

              <template v-slot:item.created_at="{ item }">
                {{ formatMySQLDate(item.created_at) }}
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { MAM__WALLET__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      headers: [
        { text: "Manager Account", value: "manager_account" },
        { text: "Investor Account", value: "investor_account" },
        { text: "Profit ($)", value: "investor_total_profit" },
        { text: "Sharing (%)", value: "profit_sharing" },
        { text: "Retained Profit ($)", value: "investor_retained_profit" },
        { text: "Amount ($)", value: "amount" },
        { text: "Start Date", value: "start_date" },
        { text: "End Date", value: "end_date" },
        { text: "Created At", value: "created_at" },
      ],
      search: "",
      filteredData: [],
      totalCommission: 0,
    };
  },

  computed: {
    ...mapState("mamWallet", ["manager_wallet_history"]),
  },

  watch: {
    manager_wallet_history(val) {
      if (val?.managerMamCommissionHistory) {
        this.filteredData = val.managerMamCommissionHistory;
      }
    },
  },

  methods: {
    formatMySQLDate(mysqlDate) {
      if (!mysqlDate) return "Invalid date";
      const isoFormattedDate = mysqlDate.replace("T", " ").split(".")[0];
      const [datePart, timePart] = isoFormattedDate.split(" ");
      const [year, month, day] = datePart.split("-");
      const [hour, minute] = timePart.split(":");
      const hour12 = hour % 12 || 12;
      const amPm = hour >= 12 ? "pm" : "am";
      return `${day}.${month}.${year} - ${hour12}:${minute} ${amPm}`;
    },

    ...mapActions("mamWallet", [
      MAM__WALLET__ACTIONS.MANAGERWALLETHISTORY,
    ]),

    managerAllAccounts() {
        const managerAccount = this.manager_wallet_history.managerMamCommissionHistory.map(
            (acc) => acc.manager_account
        );
        return ["All", ...managerAccount];
    },

    managerAccountFilter() {
        if (this.account === "All")
            return (this.filteredData = this.manager_wallet_history.managerMamCommissionHistory);
        this.filteredData = this.manager_wallet_history.managerMamCommissionHistory.filter(
            (item) => item?.manager_account.toString() === this.account.toString()
        );
    },
  },

  

  async mounted() {
    try {
      await this[MAM__WALLET__ACTIONS.MANAGERWALLETHISTORY]();
      if (this.manager_wallet_history?.managerMamCommissionHistory) {
        this.filteredData = this.manager_wallet_history.managerMamCommissionHistory;
        this.totalCommission = this.filteredData.reduce((sum, item) => {
          return sum + Number(item.amount || 0);
        }, 0);
      }
    } catch (error) {
      console.error("Error loading wallet history:", error);
    }
  },
};
</script>
